import { useCallback, useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export const CR = 10000000;
export const LAKH = 100000;

/** Wealth values are stored in natural rupees; display them in ₹ Cr (or ₹ L when small). */
export const cr = (v, digits = 4) =>
  v == null ? "—" : `₹${(v / CR).toLocaleString("en-IN", { maximumFractionDigits: digits })} Cr`;

export const inr = (v) =>
  v == null ? "—" : `₹${Number(v).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export const smart = (v) =>
  v == null ? "—" : Math.abs(v) >= CR ? cr(v, 4)
    : `₹${(v / LAKH).toLocaleString("en-IN", { maximumFractionDigits: 2 })} L`;

export const pct = (v) => (v == null ? "—" : `${Number(v).toFixed(2)}%`);

export const BUCKET_TONE = {
  safety: { color: "hsl(154 62% 36%)", chip: "bg-success/12 text-success", bar: "bg-success", border: "border-success/40" },
  market: { color: "hsl(222 72% 46%)", chip: "bg-deepblue/12 text-deepblue", bar: "bg-deepblue", border: "border-deepblue/40" },
  aspirational: { color: "hsl(288 46% 48%)", chip: "bg-plum/18 text-plumink", bar: "bg-plum", border: "border-plum/40" },
};

export const useWealthConfig = () => {
  const [config, setConfig] = useState(null);
  useEffect(() => {
    api.get("/wealth-config").then(({ data }) => setConfig(data)).catch(() => setConfig(null));
  }, []);
  return config;
};

export const useWealthPosition = () => {
  const { tenantId } = useAuth();
  const [position, setPosition] = useState(null);

  const load = useCallback(async () => {
    if (!tenantId) return;
    try {
      const { data } = await api.get(`/tenants/${tenantId}/wealth/position`);
      setPosition(data);
    } catch (e) { toast.error(errMsg(e)); setPosition({ error: errMsg(e) }); }
  }, [tenantId]);

  useEffect(() => { load(); }, [load]);
  return { position, reload: load };
};

export const WealthCrumb = ({ children }) => (
  <p className="label-caps" data-testid="wealth-crumb">{children}</p>
);
